import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MtProjectGroup } from "server/models"
import { hasProjectAccess } from "client/utils"
import { PRM_TEAM, StoreType, addModal } from "client/store"
import {
    Link,
    Default,
    UserIcon,
    DateFormatter,
    TableColumn,
    TablePopoverData,
    TablePopover,
} from "client/components"

import Edit from "./edit"
import AssignedUsers from "./users/assigned"

const Columns = () => {
    const groupUserList = useSelector((state: StoreType) => state.projectUserGroup.groupUserList)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = hasProjectAccess(PRM_TEAM, EDIT)
    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            formatter: (group: MtProjectGroup) => group.groupId,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "150px",
            formatter: (group: MtProjectGroup) => (
                <>
                    <Link
                        href="/#"
                        onClick={() => dispatch(addModal({
                            key: "editProjectGroup",
                            content: <Edit groupId={group.groupId} />,
                        }))}
                    >
                        {group.name}
                    </Link>
                    {group.default && <Default marginLeft />}
                </>
            ),
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
        },
        {
            field: "users",
            header: lang.users,
            cellMinWidth: "150px",
            formatter: (group: MtProjectGroup) => {
                const userIds = (groupUserList && groupUserList[group.groupId]) || []
                const dataList: TablePopoverData[] = []
                userIds.forEach((userId) => {
                    const user = userList[userId]
                    dataList.push({
                        id: `${user.id}_${group.groupId}`,
                        title: <UserIcon user={user} size="sm" />,
                    })
                })

                return (
                    <TablePopover
                        id={`groupUsers${group.groupId}`}
                        dataList={dataList}
                        placement="right"
                        listStyle={false}
                        title={lang.users}
                        showFirst={dataList.length === 1}
                        editAccess={editAccess}
                        onClick={() => dispatch(addModal({
                            key: "assignedGroupUsers",
                            content: <AssignedUsers group={group} />,
                        }))}
                    />
                )
            },
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellMinWidth: "200px",
            formatter: (group: MtProjectGroup) => {
                const user = userList[group.creator]
                return <UserIcon user={user} size="sm" />
            },
        },
        {
            field: "createdAt",
            header: lang.created,
            formatter: (group: MtProjectGroup) => <DateFormatter date={group.createdAt} />,
        },
    ]

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: (group: MtProjectGroup) => !group.default,
        })
    }

    return columns
}
export default Columns
